<template>
  <div v-if="filterTags.length" class="filter-tags">
    <span v-if="!showTagsOnly" class="filter-tags__filters-label">
      Filters:
    </span>
    <ul class="filter-tags__tag-list">
      <li
        v-for="{ facet, value } in filterTags"
        :key="`${facet}:${value}`"
        class="filter-tags__tag-list__tag-item"
      >
        <span class="filter-tags__tag-list__tag-item__label">
          {{ transformItemTitle(value) }}
        </span>
        <XIcon
          class="filter-tags__tag-list__tag-item__delete-icon"
          size="16"
          @click="removeFilter(facet, value)"
        />
      </li>
    </ul>
    <button
      v-if="!showTagsOnly"
      class="filter-tags__clear-btn"
      @click="clearFilters()"
    >
      Clear filters
    </button>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons'

export default {
  name: 'FilterTags',
  components: {
    XIcon,
  },
  props: {
    currentRefinements: {
      type: Object,
      required: true,
    },
    filterMap: {
      type: Object,
    },
    showTagsOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filterTags() {
      const flatedRefinements = []

      Object.entries(this.currentRefinements).forEach(([facet, values]) =>
        values.forEach(value => flatedRefinements.push({ facet, value }))
      )

      return flatedRefinements
    },
  },
  methods: {
    transformItemTitle(filter) {
      return this.filterMap[filter] || filter
    },
    removeFilter(facet, value) {
      this.$emit('remove-filter', { facet, value })
    },
    clearFilters() {
      this.$emit('clear-filters')
    },
  },
}
</script>

<style scoped lang="scss">
.filter-tags {
  display: flex;
  align-items: center;
  color: var(--white);
  &__filters-label {
    font-family: var(--font-book);
    font-style: normal;
    font-weight: 400;
    font-size: rem(12px);
    line-height: rem(14px);
    margin: 0 5px 0 0;
  }
  &__tag-list {
    display: flex;
    padding: 0;
    margin: 0 10px 0 0;
    gap: 5px;

    &__tag-item {
      display: flex;
      align-items: center;
      gap: 10px;
      background: var(--butterfly-bush);
      border-radius: 6px;
      padding: 5px 7px 5px 10px;

      &__delete-icon {
        cursor: pointer;
      }
    }
  }
  &__clear-btn {
    color: var(--white);
    padding: 8px 16px;
    border: none;
    background: transparent;
    font-family: var(--font-book);
    font-style: normal;
    font-weight: 450;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
  }
}
</style>
